import React from 'react';
import utdLogo from '../assets/Utd.jpg';
import icfaiLogo from '../assets/Icfai.jpg';

const Education = () => {
  const education = [
    {
      school: 'The University of Texas at Dallas, USA',
      degree: "Master's Degree",
      field: 'Information Technology and Management',
      period: 'May 2025',
      skills: ['Software Engineering', 'Robotic Process Automation', 'Blockchain Technology', 'BigData', 'OBject Oriented Programming with Python', 'Cloud Computing', 'Technology and New Product Developement'],
      status: "Graduated"
    },
    {
      school: 'ICFAI University, India',
      degree: "Bachelor's Degree",
      field: 'Computer Science and Engineering',
      period: 'Jan 2021',
      skills: ['Software Engineering with Javascript', 'Data Structures and Algorithms', 'Database Management Systems', 'Agile Methodologies', 'Data Science', 'Internet of Things', 'Statistics and Probability'],
      status: 'Graduated'
    }
  ];

  return (
    <section id="education" className="education-section">
      <div className="education-container-inner">
        <div className="section-header">
          <h2 className="section-title">Education</h2>
          <p className="section-subtitle">
            Continuous learning and academic excellence driving technical expertise
          </p>
        </div>

        <div className="education-grid">
          {education.map((edu, index) => (
            <div key={index} className="education-card">
              <div className="education-header">
                <div>
                  <h3 className="education-degree">{edu.degree}</h3>
                  <p className="education-school">{edu.school}</p>
                  <p className="education-field">{edu.field}</p>
                </div>
                <div className="status-logo-stack">
                  <span className={`education-status ${edu.status.includes('Expected') ? 'in-progress' : 'completed'}`}>
                    {edu.status}
                  </span>
                  {/* University/College logo */}
                  {(() => {
                    const schoolLower = edu.school.toLowerCase();
                    const logoSrc = schoolLower.includes('ut') || schoolLower.includes('texas') ? utdLogo : schoolLower.includes('icfai') ? icfaiLogo : null;
                    return logoSrc ? (
                      <div className="edu-logo-wrap">
                        <img src={logoSrc} alt={`${edu.school} logo`} className="edu-logo" />
                      </div>
                    ) : null;
                  })()}
                </div>
              </div>
              <p className="education-period">{edu.period}</p>
              
              <div className="education-skills">
                <h4>Key Coursework & Skills</h4>
                <div className="skills-list">
                  {edu.skills.map((skill, idx) => (
                    <span key={idx} className="skill-tag">{skill}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Education;
